import React from 'react';
import { getPageRect } from 'app/stores/project/page';
import { getPage, getPageImage } from 'app/stores/selectors';
import { Blurs } from 'app/views/components/editor/slide/Blurs';
import { DebugPoints } from 'app/views/components/editor/slide/Debug';
import { Marks } from 'app/views/components/editor/slide/Markers';
import { Pins } from 'app/views/components/editor/slide/Pins';
import { Spots } from 'app/views/components/editor/slide/Spots';
import { Texts } from 'app/views/components/editor/slide/Texts';
import { Image } from 'app/views/components/svg/Image';
import { LinearGradient, SVG } from 'app/views/components/svg/SVG';
import { useConnect } from 'app/views/hooks/useConnect';
import { createLinearGradient } from 'app/utils/geom';
export const SlideView = (props) => {
    var _a, _b;
    const { id: slideId, viewBox, keepAspectRatio = false } = props;
    const stateProps = useConnect((state) => {
        const slideImage = getPageImage(state, slideId);
        const page = getPage(state, slideId);
        if (!slideImage || !page) {
            return undefined;
        }
        return {
            slideImage,
            style: page === null || page === void 0 ? void 0 : page.style,
            bounds: getPageRect(page, slideImage),
        };
    });
    if (!stateProps) {
        return null;
    }
    const { slideImage, style, bounds } = stateProps;
    if (!slideImage) {
        return null;
    }
    const background = style === null || style === void 0 ? void 0 : style.background;
    let gradient;
    let backgroundFill;
    if (background) {
        switch (background.type) {
            case 'solid':
                backgroundFill = background.color;
                break;
            case 'gradient':
                gradient = createLinearGradient('gradient-0', viewBox, background.rotation, background.colors);
                backgroundFill = 'url(#gradient-0)';
                break;
            default:
                break;
        }
    }
    const hasShadow = (style === null || style === void 0 ? void 0 : style.shadow) > 0;
    const corner = (_a = style === null || style === void 0 ? void 0 : style.corner) !== null && _a !== void 0 ? _a : 0;
    const padding = (_b = style === null || style === void 0 ? void 0 : style.padding) !== null && _b !== void 0 ? _b : 0;
    return (React.createElement(SVG, { id: "project-preview", width: "100%", height: "100%", preserveAspectRatio: keepAspectRatio ? undefined : 'none', viewBox: viewBox ? `0 0 ${viewBox.width} ${viewBox.height}` : undefined },
        React.createElement("defs", null,
            React.createElement("pattern", { id: "transparent-bg", viewBox: "0,0,40,40", width: "20", height: "20", patternUnits: "userSpaceOnUse" },
                React.createElement("rect", { fill: "#FFFFFF", width: "100%", height: "100%" }),
                React.createElement("rect", { fill: "#CBCBCB", width: "20", height: "20" }),
                React.createElement("rect", { fill: "#CBCBCB", x: "20", y: "20", width: "20", height: "20" })),
            hasShadow && (React.createElement("filter", { id: "page-drop-shadow", x: "-50%", y: "-50%", width: "200%", height: "200%" },
                React.createElement("feDropShadow", { dx: "0", dy: "8", stdDeviation: style === null || style === void 0 ? void 0 : style.shadow, floodColor: "#000000", floodOpacity: "0.8" }))),
            React.createElement("filter", { id: "text-field-shadow", x: "-50%", y: "-50%", width: "200%", height: "200%" },
                React.createElement("feDropShadow", { dx: "0", dy: "4", stdDeviation: "1", floodColor: "#000000", floodOpacity: "0.2" })),
            React.createElement("clipPath", { id: "image-clip", clipPathUnits: "userSpaceOnUse" },
                React.createElement("rect", { x: bounds.x, y: bounds.y, width: bounds.width, height: bounds.height, rx: corner, ry: corner })),
            backgroundFill && React.createElement(LinearGradient, { gradient: gradient })),
        React.createElement("rect", { width: "100%", height: "100%", fill: "url(#transparent-bg)" }),
        backgroundFill && (React.createElement("rect", { width: "100%", height: "100%", fill: backgroundFill })),
        React.createElement("g", { transform: `translate(${padding},${padding})` },
            React.createElement("g", { transform: `translate(-${bounds.x}, -${bounds.y})` },
                React.createElement("g", { filter: hasShadow ? 'url(#page-drop-shadow)' : undefined },
                    React.createElement("g", { id: "image", clipPath: "url(#image-clip)" },
                        React.createElement(Image, { src: slideImage.url, width: slideImage.size.width, height: slideImage.size.height }),
                        slideImage.blurredImage && React.createElement(Blurs, null),
                        React.createElement(Spots, { slideId: slideId }))),
                React.createElement(Marks, { slideId: slideId, dataKey: "marks" }),
                React.createElement(Pins, { slideId: slideId }),
                React.createElement(Texts, { slideId: slideId }),
                React.createElement(DebugPoints, null)))));
};
